<product-icon [product]="'INVOXY'"
              [grayscale]="!invoxy_integrated"
              [tooltip_content]="tooltip_content">
</product-icon>
